import type { V2CreateAdminRepresentativeInput } from '@idc-forms/schemas/api-v2/admin-representatives'
import { useSidePanelStore } from '@/shared/store/side-panel.store'
import { useCreateRepresentativeV2Mutation } from '../hooks/use-representative-v2-mutations'
import { RepresentativeV2Form } from './representative-v2-form'

type RepresentativeV2CreatePanelProps = {
  onDone?: () => void
}

/** "Nuevo representante" contra la API v2: el mismo `RepresentativeV2Form` que la edición. */
export function RepresentativeV2CreatePanel({ onDone }: RepresentativeV2CreatePanelProps) {
  const closePanel = useSidePanelStore((s) => s.closePanel)
  const createMutation = useCreateRepresentativeV2Mutation()
  const done = onDone ?? closePanel

  const handleSubmit = (values: V2CreateAdminRepresentativeInput) => {
    createMutation.mutate(values, {
      onSuccess: () => {
        done()
      }
    })
  }

  return (
    <RepresentativeV2Form
      submitLabel="Crear representante"
      pending={createMutation.isPending}
      onSubmit={handleSubmit}
      onCancel={done}
    />
  )
}
